import React, { useState, useEffect, useRef } from "react";
import "./Enquire_form.css";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, FormGroup, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import Select from "react-select";

import Common_Btn from "../common-btn/Common_Btn";
import { AllCareer, generateInqiry } from "../../../utils/apis/career/career";
import { Controller, useForm } from "react-hook-form";
import Full_screen_modal from "../full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../lotties/success_lottie/Success_lottie";
import classNames from "classnames";
import { getData } from "../../../utils/api";

function Enquire_form({
  show,
  onSuccessSubmit,
  register,
  handleSubmit,
  reset,
  setValue,
  getValues,
  control,
  errors,
  watch,
}) {
  const [err, setErr] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const careerId = watch("career_id");

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   setValue,
  //   getValues,
  //   control,
  //   formState: { errors },
  // } = useForm({});
  const fileInputRef = useRef(null);
  const [pdfPreview, setPdfPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      setPdfPreview(URL.createObjectURL(file));
    }
  };
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("first_name", data.first_name);
      sendData.append("last_name", data.last_name);
      sendData.append("city", data.city);
      sendData.append("watsapp_no", data.watsapp_no);
      sendData.append("pincode", data.pincode);
      sendData.append("career_id", data.career_id?.value);
      sendData.append("description", data.description);

      if (data.cv?.[0]) {
        sendData.append("cv", data.cv[0]);
      }

      const response = await generateInqiry(sendData);

      if (response?.success) {
        reset({
          first_name: "",
          last_name: "",
          city: "",
          watsapp_no: "",
          pincode: "",
          description: "",
          career_id: null,
          privacy_policy: false,
          cv: "",
        });

        setShowSuccessModal(true);

        setSelectedFile(null);
        setPdfPreview(null);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        setTimeout(() => {
          setShowSuccessModal(false);
        }, 2000);
      } else {
        setErr(true);
      }
    } catch (error) {
      setErr(true);
      console.error(error);
    }
  };
  const [carrier, setCareer] = useState();

  const GetAllCareer = async () => {
    const response = await getData("/website/master/all-career");

    const option = [];
    if (response?.success) {
      response?.data?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "career_id",
          label: data.name,
        });
      });
    }
    setCareer(option);
  };

  useEffect(() => {
    GetAllCareer();
  }, []);

  useEffect(() => {
    const currentValue = getValues("career_id");

    if (typeof currentValue === "number" && carrier?.length) {
      const option = carrier.find((item) => item.value === currentValue);

      if (option) {
        setValue("career_id", option);
      }
    }
  }, [carrier]);

  return (
    <section className="enquire-section">
      <Form className="banner_form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form_grid">
          <Row>
            <Col xs={12} lg={6} className="mb-3">
              <Form.Label>
                First Name<span>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter first Name"
                className={classNames("", { "is-invalid": errors?.name })}
                {...register("first_name", {
                  required: "First Name is required",
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Only alphabets are allowed",
                  },
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                })}
              />

              {errors.first_name && (
                <p style={{ color: "red" }}>{errors.first_name.message}</p>
              )}
            </Col>

            <Col xs={12} lg={6} className="mb-3">
              <Form.Label>
                Last Name<span>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter Last Name"
                className={classNames("", { "is-invalid": errors?.name })}
                {...register("last_name", {
                  required: "Last Name is required",
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Only alphabets are allowed",
                  },
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                })}
              />

              {errors.last_name && (
                <p style={{ color: "red" }}>{errors.last_name.message}</p>
              )}
            </Col>

            <Col xs={12} lg={6} className="mb-3">
              <Form.Label>
                Enter City<span>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter City"
                className={classNames("", { "is-invalid": errors?.name })}
                {...register("city", {
                  required: "City is required",
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                })}
              />

              {errors.city && (
                <p style={{ color: "red" }}>{errors.city.message}</p>
              )}
            </Col>

            <Col xs={6} className="mb-3">
              <Form.Label>
                WhatsApp No<span>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter WhatsApp Number"
                className={classNames("", {
                  "is-invalid": errors?.watsapp_no,
                })}
                {...register("watsapp_no", {
                  required: "WhatsApp Number is required",
                  pattern: {
                    value: /^[6-9]\d{9}$/,
                    message: "Please enter a valid 10-digit mobile number",
                  },
                  minLength: {
                    value: 10,
                    message: "Mobile number must be 10 digits",
                  },
                  maxLength: {
                    value: 10,
                    message: "Mobile number must be 10 digits",
                  },
                })}
              />

              {errors.watsapp_no && (
                <p style={{ color: "red" }}>{errors.watsapp_no.message}</p>
              )}
            </Col>

            <Col xs={6} className="mb-3">
              <Form.Label>
                Pin code<span>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter Pincode"
                className={classNames("", { "is-invalid": errors?.name })}
                {...register("pincode", {
                  required: "Pincode is required",
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                })}
              />

              {errors.pincode && (
                <p style={{ color: "red" }}>{errors.pincode.message}</p>
              )}
            </Col>

            <Col xs={12} className="mb-3">
              <Form.Label>
                Apply For Position<span>*</span>
              </Form.Label>
              <Controller
                name="career_id"
                control={control}
                rules={{ required: "Position is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={carrier}
                    onChange={(option) => {
                      field.onChange(option);
                    }}
                  />
                )}
              />

              {errors.career_id && (
                <p style={{ color: "red" }}>{errors.career_id.message}</p>
              )}
            </Col>
          </Row>
        </div>

        <div className="mb-3 mt-2">
          <Form.Label>
            Describe your IT requirements / services needed
            <span>*</span>
          </Form.Label>

          <Form.Control
            type="text"
            as="textarea"
            placeholder="Enter Description"
            className={classNames("", { "is-invalid": errors?.name })}
            {...register("description", {
              required: "Description is required",
            })}
          />

          {errors.description && (
            <p style={{ color: "red" }}>{errors.description.message}</p>
          )}
        </div>

        <FormGroup>
          <Form.Label className="mt-3">
            Resume <span>*</span>
          </Form.Label>

          <Form.Control
            ref={fileInputRef}
            type="file"
            accept=".pdf"
            {...register("cv", {
              required: "Resume is required",
              onChange: handleFileChange,
            })}
          />

          {errors?.cv && (
            <Form.Text className="text-danger">{errors.cv.message}</Form.Text>
          )}

          {selectedFile && (
            <div className="mt-2">
              <strong>{selectedFile.name}</strong>
              <br />
             
            </div>
          )}

          {pdfPreview && (
            <div className="mt-3">
              <iframe
                src={pdfPreview}
                title="PDF Preview"
                width="100%"
                height="400px"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              />
            </div>
          )}
        </FormGroup>

        <div className="d-flex align-items-start gap-2 mt-4">
          <Form.Check
            type="checkbox"
            id="privacy_policy"
            {...register("privacy_policy", {
              required: "Please accept the Terms of Service and Privacy Policy",
            })}
          />

          <p className="terms_text mb-0">
            I agree to Diligencia's{" "}
            <span>
              <Link to="/terms-of-services" target="_blank">
                TERMS OF SERVICE
              </Link>{" "}
              &{" "}
              <Link to="/privacy-policy" target="_blank">
                PRIVACY POLICY
              </Link>
            </span>
          </p>
        </div>

        {errors?.privacy_policy && (
          <p className="text-danger mt-1">{errors.privacy_policy.message}</p>
        )}

        <div className="button_holder mt-3">
          <Common_Btn text={"Submit Application"} />
        </div>
      </Form>
      <Full_screen_modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        lottie={<Success_lottie />}
      />
    </section>
  );
}

export default Enquire_form;
